var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _path, _g22, _g23, _g24, _g25, _g26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIndustrySector01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.459,
    height: 24.459,
    viewBox: "0 0 24.459 24.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.625 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.625 9.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.625 11.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.625 13.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.637
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.244 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.244 9.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.244 11.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.244 13.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.637
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.911 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.911 9.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.911 11.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.911 13.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.637
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.532 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.244 6.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.911 6.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.532 6.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.532 9.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.532 11.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.683
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.532 13.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 0.637
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.197 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.197 9.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.197 11.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.683
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.197 13.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.637,
    height: 0.637
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.052,6.115H17.937V.408A.407.407,0,0,0,17.529,0H6.93a.407.407,0,0,0-.408.407h0V6.115H.408A.407.407,0,0,0,0,6.522H0V21.2a.407.407,0,0,0,.407.408H1.26a2.446,2.446,0,0,0-.037.408v2.038a.407.407,0,0,0,.407.408h21.2a.407.407,0,0,0,.408-.407h0V22.013a2.436,2.436,0,0,0-.037-.408h.852a.407.407,0,0,0,.408-.407h0V6.522A.407.407,0,0,0,24.052,6.115ZM17.529,17.529a.815.815,0,1,1-.815-.815A.815.815,0,0,1,17.529,17.529Zm-9.784-.815a.815.815,0,1,1-.815.815A.815.815,0,0,1,7.745,16.714ZM5.3,23.644H2.038V22.013a1.631,1.631,0,1,1,3.261,0ZM2.854,18.752a.815.815,0,1,1,.815.815A.815.815,0,0,1,2.854,18.752Zm2.508,1.5a2.457,2.457,0,0,0-.513-.38,1.631,1.631,0,1,0-2.359,0,2.462,2.462,0,0,0-.935.918H.815V6.93H6.522v9.532a1.608,1.608,0,0,0,.043,2.187A2.453,2.453,0,0,0,5.361,20.251Zm4.015,3.392H6.115V20.79a1.631,1.631,0,1,1,3.261,0Zm4.892,0H10.191V20.79a2.038,2.038,0,1,1,4.076,0Zm-3.261-6.93a1.223,1.223,0,1,1,1.223,1.223A1.223,1.223,0,0,1,11.007,16.714Zm3.706,2.675a2.871,2.871,0,0,0-1.17-1.129,2.038,2.038,0,1,0-2.626,0,2.871,2.871,0,0,0-1.17,1.129,2.462,2.462,0,0,0-.822-.74,1.619,1.619,0,0,0-1.587-2.693V.815h9.784V15.956a1.623,1.623,0,0,0-1.587,2.693A2.462,2.462,0,0,0,14.712,19.389Zm3.632,2.625v1.631H15.083V20.79a1.631,1.631,0,0,1,3.261,0Zm4.076,1.631H19.16V22.013a1.631,1.631,0,1,1,3.261,0Zm-2.446-4.892a.815.815,0,1,1,.815.815A.815.815,0,0,1,19.975,18.752Zm3.669,2.038h-.739a2.462,2.462,0,0,0-.935-.918,1.631,1.631,0,1,0-2.359,0,2.456,2.456,0,0,0-.513.38,2.453,2.453,0,0,0-1.2-1.6,1.608,1.608,0,0,0,.043-2.187V6.93h5.707V20.79Z",
    transform: "translate(0 0)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.271 9.957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 5.37
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.099 9.957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 5.37
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.677 9.957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 5.37
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.505 9.957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.683,
    height: 5.37
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.884 1.34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M188.356,32h-4.021a.335.335,0,0,0-.335.335h0v2.68a.335.335,0,0,0,.335.335h4.021a.335.335,0,0,0,.335-.335h0v-2.68A.335.335,0,0,0,188.356,32Zm-.335,2.68h-3.35V32.67h3.35Z",
    transform: "translate(-184 -32)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustrySector01);
export default __webpack_public_path__ + "static/media/Icon-IndustrySector-01.f5d18d37548116cec90ceb98c77682f9.svg";
export { ForwardRef as ReactComponent };